import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, when } from 'mobx';
import { injectIntl } from 'react-intl';

import messages from './Awards.intl';

//styles
import styles from './Awards.module.scss';

import { Container } from 'common/components/Layout/Layout';

import ContentStore from 'stores/Content.store';

import Award from './components/Award/Award';
import Carousel from 'common/components/Carousel/Carousel';

@injectIntl
@observer
export default class Awards extends Component {
  awards = observable([]);

  carouselSettings = {
    className: styles.Carousel,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          adaptiveHeight: true
        }
      }
    ]
  };

  componentDidMount() {
    when(
      () => ContentStore.isLoaded,
      () => this.awards.replace(ContentStore.content.homePageAwards)
    );
  }

  render() {
    return (
      ContentStore.isLoaded && (
        <Container>
          <div className={styles.SectionWrapper}>
            <h3 className={styles.Title}>
              {this.props.intl.formatMessage(messages.heading)}
            </h3>
            <Carousel settings={this.carouselSettings}>
              {this.awards.map(award => <Award key={award.id} award={award} />)}
            </Carousel>
          </div>
        </Container>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Awards/Awards.js